import { request } from "../../apis";

export const apiGetCoaches = (params: any): any =>
  request("get", `/api/coach/available/list`, params, true);

export const apiGetCoachInfo = (params: any): any =>
  request("get", `/api/coach/info/${params.coach_id}`, params, true);

export const apiGetCoachSchedule = (params: any): any =>
  request("get", `/api/coach/schedule/${params.coach_id}`, params, true);
